import { render, staticRenderFns } from "./noRecord.vue?vue&type=template&id=21b4d0f5&"
import script from "./noRecord.vue?vue&type=script&lang=js&"
export * from "./noRecord.vue?vue&type=script&lang=js&"
import style0 from "./noRecord.vue?vue&type=style&index=0&lang=scss&scope=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports